module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_09-6c01cf820f36a72c4815b66d07272e77.svg";